import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    rcaDashboardContentWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    },
}));
